import { Link } from "react-router-dom";
import styled from "styled-components";
import { DESKTOP as LG } from "../marketing.styles";

export const HeroGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  row-gap: 28px;

  @media ${LG} {
    grid-template-columns: minmax(0, 1fr) 725px;
    column-gap: 80px;
    align-items: stretch;
  }
`;

export const LeftColumn = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  /* O ZoomWrapper aplica scale(0.8) a partir de lg: 1.25 devolve as medidas do desenho */
  @media ${LG} {
    zoom: 1.25;
  }
`;

export const LeftTop = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CardColumn = styled.div`
  min-width: 0;

  @media ${LG} {
    align-self: start;
  }
`;

export const BackChip = styled(Link)`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 18px 0 14px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: 15px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(23, 65, 90, 0.08);
  transition: background 0.15s;

  & svg {
    width: 18px;
    height: 18px;
    transition: transform 0.15s;
  }

  &:hover {
    background: ${({ theme }) => theme.colors.white};
  }

  &:hover svg {
    transform: translateX(-3px);
  }
`;

export const Intro = styled.div`
  margin-top: 36px;

  /* Topo das letras do título na mesma linha do primeiro campo do card */
  @media ${LG} {
    margin-top: 40px;
  }
`;

export const Title = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: 38px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: 1.12;
  letter-spacing: -0.03em;

  @media ${LG} {
    font-size: clamp(40px, 8px + 3.2vw, 64px);
  }
`;

export const Mark = styled.span`
  display: inline;
  margin-left: -0.06em;
  padding: 0 0.16em 0.02em;
  border-radius: 0.14em;
  background: ${({ theme }) => theme.colors.deepDarkBlue};
  color: ${({ theme }) => theme.colors.white};
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
`;

export const Lead = styled.p`
  max-width: 480px;
  margin: 18px 0 0;
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  line-height: 1.55;
  text-wrap: pretty;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 18px;
  }
`;

export const Route = styled.div`
  margin-top: 20px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 32px;
  }
`;

export const RouteBox = styled.div`
  position: relative;
  aspect-ratio: 520 / 150;
`;

export const RouteSvg = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: visible;
`;

export const RoutePath = styled.path`
  fill: none;
  stroke: ${({ theme }) => theme.colors.white};
  stroke-width: 4;
  stroke-linecap: round;
  stroke-dasharray: 0.1 12;
`;

export const Plane = styled.img`
  position: absolute;
  left: 50%;
  top: 33%;
  width: 44px;
  height: auto;
  transform: translate(-50%, -50%) rotate(25deg);

  @media ${LG} {
    width: 56px;
  }
`;

export const Ends = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: start;
  gap: 12px;
  margin-top: 8px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    align-items: end;
  }
`;

export const End = styled.div<{ $right?: boolean }>`
  min-width: 0;
  text-align: ${({ $right }) => ($right ? "right" : "left")};
`;

export const EndCode = styled.p<{ $ghost?: boolean }>`
  margin: 0;
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: ${({ $ghost }) => ($ghost ? "16px" : "22px")};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  letter-spacing: ${({ $ghost }) => ($ghost ? "0" : "0.02em")};
  line-height: 1;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ $ghost }) => ($ghost ? "18px" : "28px")};
  }
`;

export const EndCity = styled.p`
  margin: 4px 0 0;
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: 13px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 14px;
  }
`;

export const EndDate = styled.p`
  margin: 2px 0 0;
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: 13px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;

export const PriceBadge = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  padding: 6px 12px;
  border-radius: 14px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0 8px 20px rgba(23, 65, 90, 0.14);
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 8px 16px;
  }
`;

export const PriceLabel = styled.span`
  color: #5b6b75;
  font-size: 11px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

export const PriceValue = styled.span`
  color: ${({ theme }) => theme.colors.darkBlue};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  white-space: nowrap;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 20px;
  }
`;

export const Bottom = styled.div`
  margin-top: 24px;

  @media ${LG} {
    margin-top: 0;
  }
`;

export const Facts = styled.ul`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  margin: 0;
  padding: 16px 0 0;
  border-top: 2px solid rgba(23, 65, 90, 0.18);
  list-style: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 16px;
    padding-top: 20px;
  }
`;

export const Fact = styled.li`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 6px;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`;

export const FactTitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`;

export const FactText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.deepDarkBlue};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  line-height: 1.4;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-top: 2px;
  }
`;
